const getCanonicalLink = (customPathName = "") => {
  const { protocol, hostname, pathname } = window.location;
  return `${protocol}//${hostname.replace(/^www\./, "")}${
    customPathName.length ? customPathName : pathname
  }`;
};

export default getCanonicalLink;
